import LottieAnimation from '@base/LottieAnimation/LottieAnimation';
import styled from '@emotion/styled';
import Skeleton from '@material-ui/lab/Skeleton';
import { Spacings, mediaQuery } from '@styles/index';
import { getAnimationPath } from '@utils/animationHelpers';
import boxShadowGenerator from '@utils/boxShadowGenerator';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 1/8;
  min-height: 320px;
  background: var(--color-base-1);
  padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_6B} ${Spacings.SPACING_3B};
  border-radius: ${Spacings.SPACING_2B};
  box-shadow: ${boxShadowGenerator()};
  ${mediaQuery.uptoTablet} {
    grid-column: 1/11;
  }
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_3B};
  }
`;

const SkeletonWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AnimationContainer = styled(LottieAnimation)`
  width: 270px;
  height: 540px;
`;

const GroupsOnboardingLoader = () => {
  return (
    <Wrapper>
      <AnimationContainer
        src={getAnimationPath('findingGroup.json')}
        Skeleton={
          <SkeletonWrapper>
            <Skeleton
              variant="circle"
              width={Spacings.SPACING_5B}
              height={Spacings.SPACING_5B}
            />
          </SkeletonWrapper>
        }
      />
    </Wrapper>
  );
};

export default GroupsOnboardingLoader;
